import Image from "next/image";
import Button from "@/Components/Button";
import Breadcrumb from "@/Components/Breadcrumb/Breadcrumb";
import KeenSlider from "./slider";
import MobileSlider from "./mobileSlider";
import { toWebp } from "@/utils/common";
import Link from "next/link";

type BannerProps = {
  data?: any;
  parent?: string;
  isMobile?: boolean;
  breadcrumbs?: any;
};

const Banner: React.FC<BannerProps> = ({ isMobile, data, breadcrumbs }) => {
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";
  const manufacturingData = data?.slideManufacturing;

  return (
    <section className="relative bg-background-dark text-white pt-[140px] xl:pt-[180px] py-[56px] xl:py-[100px] md:pt-[154px] md:py-[80px] overflow-hidden">
      {/* Background Image */}
      {/* {!isMobile ? (
        <>
          <Image
            src="/images/consulting/banner-top.png"
            width={571}
            height={571}
            alt="banner-top"
            className="absolute w-[571px] h-[571px] top-[-80px] left-0 z-1 bg-cover bg-no-repeat bg-center hidden sm:block"
            quality={80}
            loading="eager"
            priority
          />
          <Image
            src="/images/consulting/banner-bottom.png"
            width={470}
            height={470}
            alt="banner-bottom"
            className="absolute w-[470px] bottom-0 right-0 z-1 bg-cover bg-no-repeat bg-center hidden sm:block"
            quality={80}
            loading="eager"
            priority
          />
        </>
      ) : (
        <>
          <Image
            src="/images/consulting/mobile-blue.png"
            width={600}
            height={600}
            alt="mobile-bg"
            className="absolute w-full h-full top-0 left-0 z-0 object-cover block sm:hidden"
            quality={80}
            loading="eager"
            priority
          />
          <Image
            src="/images/consulting/mobile-green.png"
            width={600}
            height={600}
            alt="mobile-bg"
            className="absolute w-full h-full bottom-0 right-0 z-0 object-cover block sm:hidden"
            quality={80}
            loading="eager"
            priority
          />
        </>
      )} */}

      {/* Content */}
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="flex flex-col items-center justify-center mx-auto">
          {breadcrumbs?.item?.length > 0 && (
            <Breadcrumb
              items={breadcrumbs?.item ?? []}
              className2="text-subtitle-3 text-center text-gray-300"
              className=" text-gray-300 xl:mb-[32px] md:mb-[16px] mb-[16px] xl:mt-[0] whitespace-nowrap overflow-hidden w-[95%] text-ellipsis flex-row text-subtitle-3 md:text-subtitle-3 md:mt-[0] flex items-center justify-center text-center"
            />
          )}
          {!isMobile && (
            <>
              <KeenSlider>
                {manufacturingData.map((item: any, index: number) => (
                  <div
                    key={index}
                    className="max-auto text-center flex items-center flex-col"
                  >
                    {index == 0 ? (
                      <h2 className="text-display font-extrabold max-auto text-center text-primary-text-white uppercase max-w-[1230px] mb-[32px] md:min-h-[146px]">
                        {item?.title}
                      </h2>
                    ) : (
                      <span className="text-display font-extrabold max-auto text-center text-primary-text-white uppercase max-w-[1230px] mb-[32px] md:min-h-[146px]">
                        {item?.title}
                      </span>
                    )}

                    <div className="flex items-center justify-center mb-[32px] mx-auto text-center xl:w-[1280px] lg:w-[1078px] md:w-full">
                      <Image
                        src={toWebp(
                          `${baseUrl}${item?.image?.data?.attributes?.url}`,
                        )}
                        alt={item?.title}
                        width={1081 * 2}
                        height={415 * 2}
                        className="h-[415px] min-h-[415px] max-h-[415px] w-full xl:object-cover object-cover"
                        quality={100}
                        loading="eager"
                        priority
                      />
                    </div>

                    <div className="grid text-start grid-cols-12 mx-auto xl:max-w-[1280px] lg:max-w-[1078px]">
                      <div className="xl:col-span-5 col-span-5 md:col-span-6 ">
                        <h4 className="text-heading-4 font-bold  text-left max-[412px]">
                          {item?.sub_title}
                        </h4>
                      </div>
                      <div className="xl:col-span-7 col-span-7 md:col-span-6 xl:pl-3 md:pl-2">
                        <p className="text-secondary-text-white text-subtitle-2 font-regular  xl:max-w-[1230px] max-w-[609px] sm:mt-[0] mt-[0]">
                          {item?.description}
                        </p>
                        {item?.link?.label && item?.link?.href && (
                          <a href={item?.link?.href} className="inline-block">
                            <Button
                              label={item?.link?.label}
                              className="mt-[16px]"
                            />
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </KeenSlider>
            </>
          )}
        </div>
      </div>

      {isMobile && (
        <>
          <MobileSlider>
            {manufacturingData.map((item: any, index: number) => (
              <div
                key={index}
                className="mx-auto text-center flex flex-col items-center"
              >
                {/* Title */}
                {index == 0 ? (
                  <h1 className="text-display font-extrabold max-auto text-center text-primary-text-white uppercase max-w-full mb-[32px]  max-[391px]:text-[32px] max-[340px]:text-[28px]">
                    {item?.title}
                  </h1>
                ) : (
                  <span className="text-display font-extrabold max-auto text-center text-primary-text-white uppercase max-w-full mb-[32px] max-[391px]:text-[32px] max-[340px]:text-[28px]">
                    {item?.title}
                  </span>
                )}

                {/* Image */}
                <div className="flex items-center justify-center mb-[32px] w-full">
                  <Image
                    src={toWebp(
                      `${baseUrl}${item?.image?.data?.attributes?.url}`,
                    )}
                    alt={item.title}
                    width={300}
                    height={415}
                    className="h-[415px] object-cover w-full"
                    quality={100}
                    loading="eager"
                    priority
                  />
                </div>

                {/* Text + Button */}
                <div className="flex flex-col items-center text-center">
                  <h4 className="text-heading-4 font-bold mb-3">
                    {item?.sub_title}
                  </h4>
                  <p className="text-secondary-text-white text-subtitle-2 font-regular">
                    {item?.description}
                  </p>
                  {item?.link?.label && item?.link?.href && (
                    <div className="relative z-20 w-full">
                      <Link href={item?.link?.href} className="w-full block">
                        <Button
                          label={item?.link?.label}
                          className="mt-[16px] w-full"
                        />
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </MobileSlider>
        </>
      )}
    </section>
  );
};

export default Banner;
